import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { keys } from "./keys";

async function fetchSubTopic(id: string) {
  const { data, error } = await apiClient
    .from('sub_topics')
    .select(`*,
      topics (
        id, 
        name
      )`)
    .eq('id', id)
    .limit(1)
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export function useGetSubTopicByIdWithTopic(id: string | undefined) {

  return useQuery({
    queryKey: keys.subTopic(id ?? ''),
    queryFn: () => fetchSubTopic(id!),
    enabled: !!id,
    staleTime: _3_DAYS
  })
}
